import { Box, Container, Typography } from "@mui/material";
interface Title {
  title: string;
  smallTitle: string;
}

const TitleHeader = (data: Title) => {
  return (
    <Container className="container-xxl">
      <Box className="d-flex flex-wrap align-items-center gap-1 border-bottom gap-3 py-5">
        <Typography className="d-flex flex-column gap-1 fw-bold">
          {data.title}
        </Typography>
        <Box className="text-muted text-break">{data.smallTitle}</Box>
      </Box>
    </Container>
  );
};

export default TitleHeader;
